module.exports = __webpack_public_path__ + "components/flash/static/cross-0ea1bd7c8531c7437ba8b35d63239d5d.svg";